import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import template from './confirmation-screen.jade'
import '../seasons'
import { Match } from '../../models'
import notify from '@scoutgg/ftw/source/services/notification'
import emitter from '@scoutgg/ftw/source/services/emitter'

@Component('sporty')
@Template(template)
@Attribute('match', Match)

export default class ConfirmationScreen extends HTMLElement {
  attached() {
    this.matchChange()
  }

  load() {
    
  }

  get matches() {

  }
  saveStats() {
    var lineups = this.match.lineups.map(lineup => {
      return {
        _id: lineup._id,
        batch: lineup.batch || 0,
        match: lineup.matchId,
        player: lineup.playerId,
        team: lineup.teamId,
        stats: lineup.stats,
        status: lineup.status,
        duration: lineup.duration,
        lane: lineup.lane,
      }
    })
    this.match.post('edit-stats', { lineups }).then(() => {
      notify('Stats saved', { level: 'success', timeout: 3000 })
      emitter.emit('match-updated')
      this.render()
    })
  }
  
  async matchChange() {
    const data = this.match.load()
    this.update(data)
    if(!this.lineups) this.lineups = []
    this.render()
  }

  get batches() {
    const batches = this.lineups.reduce((a, b) => !(a.includes(b.batch)) ? a.concat(b.batch) : a, [])
    batches.sort()
    if(!batches[0]) {
      return undefined
    } else {
      return batches
    }
  }
}
